// extracted by mini-css-extract-plugin
module.exports = {"align-center":"_5DJ4VWha","description":"_5D2xN7Hw","list-action-container":"_5D3MK95W","list-item-header":"_5D1oEtq5","is-assign":"_5D2SibdD","loader":"_5D1ienn7"};